import { isSuburban } from '../../../../packages/JsonQuery';
import { MOSCOW_AND_REGION, SPB_AND_REGION } from 'shared/constants/regions';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { selectRegions } from 'shared/selectors/regions';
import { TLocation } from 'shared/types/location';
import { TAsyncThunkAction } from 'shared/types/redux';
import { applyLocation } from './applyLocation';
import { TGeoObject } from 'shared/types/geoSuggest';
import { selectDistrict } from '../districtsSwitcher/selectDistrict';
import { updateGeo } from './updateGeo';
import { setUserInput } from 'shared/slices/geo';

interface IParam {
  value: TGeoObject;
  userInput: string;
}

export const selectGeo =
  ({ value, userInput }: IParam): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const { locationInfo, district } = value;
    const state = getState();
    const regions = selectRegions(state);
    const offerType = selectOfferType(state);

    if (locationInfo) {
      dispatch(applyLocation(locationInfo));
    } else {
      const location = regions.find(r => r.id === value.id) || regions.find(r => r.id === value.regionId);

      let extendedLocation: TLocation | undefined = location;

      if (isSuburban(offerType) && location) {
        switch (true) {
          case MOSCOW_AND_REGION.includes(location.id):
            extendedLocation = 'moscow_mo';
            break;
          case SPB_AND_REGION.includes(location.id):
            extendedLocation = 'spb_lo';
            break;
        }
      }

      dispatch(applyLocation(extendedLocation));
    }

    if (district) {
      await dispatch(selectDistrict(district));
    }

    await dispatch(updateGeo(value));
    dispatch(setUserInput(userInput));
  };
